const now = new Date();
// Set to midnight UTC (clearing milliseconds)
now.setUTCFullYear(now.getUTCFullYear());
now.setUTCMonth(now.getUTCMonth());
now.setUTCDate(now.getUTCDate());
now.setUTCSeconds(0);
now.setUTCMilliseconds(0);

// Format the date string
const utcString = now.toISOString()
    .replace('T', ' ')  // Replace 'T' with space
    .replace('.000Z', ' UTC'); // Remove milliseconds and timezone

document.getElementById('utc-time').textContent = utcString;